<template>
  <v-container class="ma-10 mx-auto" style="max-width: 300px;">
    <vue-headful title="Account Aktivierung" description="Aimz"/>

    <v-row class="pt-10 pb-3">
      <v-col>
        <h1 class="display-1 gelb--text">Accountaktivierung</h1>
      </v-col>
    </v-row>

    <div v-if="status=='activate_with_code'">Aktivierungscode prüfen ...</div>
    <div v-else-if="status=='activated'">
      <v-alert type="success">
        Ihr Account wurde aktiviert.
      </v-alert>
      Sie können sich nun <router-link :to="email ? '/login/'+email : '/login'">einloggen</router-link>
    </div>
    <div v-else-if="status=='activation_failed'">
      <v-alert type="error">
        Aktivierung fehlgeschlagen
      </v-alert>
      <p>
        {{activation_error}}
      </p>
      <p>
        Probieren Sie es <router-link to="/verify">noch einmal.</router-link>
      </p>
    </div>
    <div v-else-if="status=='resend'">
      <v-text-field label="Email" v-model="email"></v-text-field>
      <v-btn color="#d30228" class="full_width white--text mt-5" @click="onResendEmail">Aktivierungsemail senden</v-btn>
    </div>
    <div v-else-if="status=='email_sent'">
      <v-alert type="success">
        Ein neuer Aktivierungslink wurde an {{email}} gesendet.
      </v-alert>
      <p>
        Tip: prüfen Sie auch den Spamordner.
      </p>
    </div>
    <div v-else-if="status=='resend_failed'">
      <v-alert type="error">
        Es konnte kein Aktivierungslink an {{email}} gesendet werden.
      </v-alert>
      <p>
        {{resend_error}}
      </p>
      <v-btn class="full_width" dark @click="request_verification_email">Neuer Versuch</v-btn>
    </div>
  </v-container>
</template>


<script>
  // @ is an alias to /src

  export default {
    name: 'Verify',
    components: {  },
    data() {return{
      status:'activate', // resend | email_sent | activate_with_code | activated ...
      email:'',
      activation_error:undefined,
      resend_error:undefined,
    }},
    mounted() {
      this.onRouteChange();
    },
    methods:{
      verify(id) {
        this.status='activate_with_code'
        this.$backend.verify( id, { onSuccess:this.onSuccess, onError:this.onError });
      },
      onSuccess(email) {
        this.status='activated';
        this.email=email;
      },
      onError(reason) {
        this.status='activation_failed';
        this.activation_error=reason;
        // display email textbox to resend code
      },
      onResendEmail() {
        this.$backend.request_activation_email( this.email, {
          onSuccess:()=>{
            this.status="email_sent";
          },
          onError:(reason)=> {
            this.status="resend_failed";
            this.resend_error=reason;
          }});
      },
      request_verification_email() {
        this.status="resend";
        this.email='';
      },
      onRouteChange(){
        var id=this.$route.params.id;
        if (id)
          this.verify(id);
        else
          this.request_verification_email();
      },
    },
    watch: {
      $route(to, from) {
        // react to route changes...
        // console.log("$route(to, from)")
        this.onRouteChange();
      }
    }
  }
</script>
